import { OrderConfig } from "../common/types"

export interface Folder {
  id: number
  name: string
  created_at_epoch: number
  parent_folder_id: number | null
  access_type_id: number
  portal_id: number
  files: number[]
}

export type MentorCloudFileExtension = 'image' | 'video' | 'pdf' | 'audio' | '*'
export interface MentorCloudFileFilters {
  search: string,
  order: OrderConfig,
  type: MentorCloudFileExtension
}

export interface MentorCloudFile {
  id: number
  name: string
  size: number
  tags: string
  file_id: string
  extension: string
  portal_id: number
  parent_folder_id: number | null
  access_type_id: number
  created_at_epoch: number
  preview_file_id: string | null
  preview_link: string | null
}

export const mentorCloudExtensions = {
  image: ['.png', '.jpg', '.jpeg', '.webp', '.svg', 'png', 'jpg', 'jpeg', 'webp', 'svg'],
  video: [
    '.mp4',
    '.ogg',
    '.webm',
    '.mov',
    '.mkv',
    '.flv',
    '.vob',
    '.ogv',
    '.avi',
    '.m4v',
    '.mpg',
    '.mp2',
    '.mpeg',
    '.mpe',
    '.mpv',
    '.flv',
    '.f4v',
    'mp4',
    'ogg',
    'webm',
    'mov',
    'mkv',
    'flv',
    'vob',
    'ogv',
    'avi',
    'm4v',
    'mpg',
    'mp2',
    'mpeg',
    'mpe',
    'mpv',
    'flv',
    'f4v'
  ],
  pdf: ['.pdf', 'pdf'],
  audio: ['.mp3', 'mp3']
}